<template>
    <b-row id="futurocoin_stats_component"
           class="futurocoin-stats-component">
        <b-col lg="4" md="4" cols="12"
               v-for="(stat, index) in stats"
               :key="index">
            <stats-item :label="stat.label"
                        :value="stat.value"
                        v-if="!stat.royal || stat.royal && royalPosition > 0"></stats-item>
        </b-col>
    </b-row>
</template>

<script>
    import StatsItem from './futurocoin-stats/StatsItem.vue'
    export default {
        dependencies: ['money'],
        components: { StatsItem },
        computed: {
            royalPosition () {
                return this.$store.getters.ftoAccounts.royalBonusAccount;
            },
            stats () {
                return {
                    1: {
                        label: 'All FuturoCoins<br class="desktop-only"> from mining',
                        value: this.money.format(this.$store.getters.ftoAccounts.miningOriginalAccount, 'fto'),
                        royal: false
                    },
                    2: {
                        label: 'Available FuturoCoins<br class="desktop-only"> from mining',
                        value: this.money.format(this.$store.getters.ftoAccounts.miningAccount, 'fto'),
                        royal: false
                    },
                    3: {},
                    4: {
                        label: 'All FuturoCoins<br class="desktop-only"> from Royal Position',
                        value: this.money.format(this.$store.getters.ftoAccounts.royalBonusOriginalAccount, 'fto'),
                        royal: true
                    },
                    5: {
                        label: 'Available FuturoCoins<br class="desktop-only"> from Royal Position',
                        value: this.money.format(this.$store.getters.ftoAccounts.royalBonusAccount, 'fto'),
                        royal: true
                    },
                    6: {
                        label: 'FuturoCoins<br class="desktop-only"> from Royal Position to withdraw',
                        value: this.money.format(this.$store.getters.ftoAccounts.allowToWithdrawFromRoyal, 'fto'),
                        royal: true
                    }
                }
            }
        }
    }
</script>

<style lang="scss">
    .futurocoin-stats-component{
        margin: 55px -15px 0;
    }

    @media(max-width: 360px){
        .futurocoin-stats-component{
            margin: 30px -15px 0;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/layout/partials/section/content/futurocoin/FuturocoinStats.vue